import type { TtvDraggedPhoneme } from "@/app/(application)/(ttv)/ttv/analytics/types";
import { getPhonemeGuideEntry } from "@/app/(application)/(ttv)/ttv/components/ttvApplication/pianoRoll/phonemes/guide/getPhonemeGuideEntry";
import { isValidPhoneme } from "@/app/(application)/(ttv)/ttv/components/ttvApplication/pianoRoll/phonemes/isValidPhoneme";
import { isVowel } from "@/app/(application)/(ttv)/ttv/components/ttvApplication/pianoRoll/utils/lyrics/isVowel";

// One trailing ARPAbet stress digit (0 unstressed, 1 primary, 2 secondary), as dictionary output carries it on vowels.
const TRAILING_STRESS_DIGIT = /[012]$/;

// A stored or typed phoneme label as analytics may carry it: the model's inventory token, lower-cased and trimmed so "AH" and "ah" count as one sound, with its stress digit stripped so "AH1" counts as "ah" too, plus its class. The guide classifies the sounds it lists; the model markers it does not list (cl, vf) fall back to the lyric pipeline's vowel test, and everything that is not a vowel there is articulation. Null for anything outside the inventory, which is free text and never leaves the browser.
export const toTtvDraggedPhoneme = (
  phonemeText: string
): TtvDraggedPhoneme | null => {
  const code = phonemeText
    .trim()
    .toLowerCase()
    .replace(TRAILING_STRESS_DIGIT, "");
  if (!isValidPhoneme(code)) {
    return null;
  }
  const guideKind = getPhonemeGuideEntry(code)?.kind ?? null;
  if (guideKind !== null) {
    return { code, kind: guideKind };
  }
  return { code, kind: isVowel(code) ? "vowel" : "consonant" };
};
